import { motion } from "framer-motion";
import { Palette, Sprout, Sun, TreePine, Droplets, Gem } from "lucide-react";
import { APPROACH, revealUp } from "../../lib/mrs";

const ICONS = [Palette, Sprout, Sun, TreePine, Droplets, Gem];

export const Approach = () => {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative bg-[#0a0b0a] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-2xl mb-14 md:mb-20">
        <motion.p
          variants={revealUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#b89b72] mb-5"
        >
          Our Approach
        </motion.p>
        <motion.h2
          variants={revealUp}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="font-display font-light text-[#eae7e0] leading-[1.05] text-4xl md:text-5xl lg:text-6xl tracking-tight"
        >
          Your style, brought to life, with nature at its heart.
        </motion.h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#eae7e0]/10 border border-[#eae7e0]/10">
        {APPROACH.map((a, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={a.title}
              variants={revealUp}
              custom={i % 3}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              data-testid={`approach-card-${i}`}
              className="group bg-[#121412] p-8 md:p-10 lg:p-12 transition-colors duration-500 hover:bg-[#161915]"
            >
              <Icon
                size={30}
                strokeWidth={1}
                className="text-[#b89b72] mb-8 transition-transform duration-500 group-hover:-translate-y-1"
              />
              <h3 className="font-display text-2xl md:text-3xl font-normal text-[#eae7e0] mb-3">
                {a.title}
              </h3>
              <p className="text-sm md:text-base text-[#9ca399] leading-relaxed">
                {a.desc}
              </p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
